/*
'use strict';

angular.module('amexReconciliationApp')
  .service('PreferredAccountingFieldSchemaRepository', function ($resource, $q) {
    var self = this;
    var RESOURCE_URL = '/api/v1/preferredAccountingFieldSchemas';

    self.findBySiteNumber = function (siteNumber) {
      return $q(function (resolve) {
        $resource(RESOURCE_URL, {siteNumber: siteNumber}).query().$promise
          .then(function (response) {
            resolve(response);
          })
          .catch(function () {
            resolve([]);
          });
      });
    };

    self.update = function (siteNumber, columnPosition, accountingFieldSchemaPosition) {
      $resource(RESOURCE_URL).save({
        siteNumber: siteNumber,
        columnPosition: columnPosition,
        accountingFieldSchemaPosition: accountingFieldSchemaPosition
      });
    };
  });
*/



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/PreferredAccountingFieldSchemaRepository.js
// module id = 615
// module chunks = 0